<ng-template #successAllowedIpTemplate>
  {{ 'CLOUD-LICENSE-SERVER.DASHBOARD.MESSAGES.SUCCESS-ALLOWED-IP' | translate: { allowedIp } }}
</ng-template>

<div class="af-content-wrapper">
  <af-card>
    <div class="af-license-server-content" content>
      <kendo-label [text]="'CLOUD-LICENSE-SERVER.DASHBOARD.ADDRESS' | translate"></kendo-label>
      <kendo-textbox
        [value]="licenseServerAddress() ?? ('CLOUD-LICENSE-SERVER.DASHBOARD.URL-NOT-AVAILABLE' | translate)"
        (valueChange)="licenseServerAddress.set($event)"
        [readonly]="true"
      ></kendo-textbox>

      <button
        kendoButton
        type="button"
        [disabled]="!licenseServerAddress() || isLoading() || isAllowingIp()"
        (click)="allowAccessFromCurrentIp()"
      >
        {{ 'CLOUD-LICENSE-SERVER.DASHBOARD.ALLOW-ACCESS' | translate }}
      </button>

      @if (errorMessage()) {
        <af-form-error [message]="errorMessage() | translate"></af-form-error>
      }
    </div>
  </af-card>
</div>
